import { FilterOption, CriteriaType, Time, Price } from './TripSearchFilterModel';


var timeOptionGroup: FilterOption<CriteriaType, Time>[] = [
    {
        key: "time",
        value: "MORNING",
        icon: "fas fa-sun",
        type: "filter",
        getLabel:(messageProvider)=>{
            return messageProvider.get("trip.morning")
        }
    },

    {
        key: "time",
        value: "AFTERNOON",
        icon: "fas fa-moon",
        type: "filter",
        getLabel:(messageProvider)=>{
            return messageProvider.get("trip.afternoon")
        }
    },

    {
        key: "time",
        value: "EVENING",
        icon: "fas fa-moon",
        type: "filter",
        getLabel:(messageProvider)=>{
            return messageProvider.get("trip.evening")
        }
    },
];

var priceOptionGroup: FilterOption<CriteriaType, Price>[] = [

    {
        key: "price",
        value: "Low to High",
        icon: "fas fa-sort-amount-down",
        type: "sort",
        getLabel:(messageProvider)=>{
            return messageProvider.get("price_low_high")
        }
    },

    {
        key: "price",
        value: "High to Low",
        icon: "fas fa-sort-amount-up",
        type: "sort",
        getLabel:(messageProvider)=>{
            return messageProvider.get("price_high_low")
        }
    },
];

export function getTimeOptionGroup() {
    return [...timeOptionGroup];
}

export function getPriceOptionGroup() {
    return [...priceOptionGroup];
}
